import WidgetEditorFrame from './widget-editor-iframe';

export default WidgetEditorFrame;
